@if (data) {
  @switch (data.layout) {
    @case (layout.LAYOUT1) {
      <app-list-layout-1 [data]="data.data" />
    }
    @case (layout.LAYOUT2) {
      <app-list-layout-2 [data]="data.data" />
    }
    @case (layout.LAYOUT3) {
      <app-list-layout-3 [data]="data.data" />
    }
  }
}
